export default __webpack_public_path__ + "5dc38850217b4181e3b7d56c61652a3f.svg";